// extracted by mini-css-extract-plugin
export var dropdown = "_h0-0";
export var imagePlaceholder = "_h0-2";
export var imageWrapper = "_h0-3";
export var productImage = "_h0-1";
export var truncateContainer = "_h0-4";
export var truncateText = "_h0-5";